import { createBrowserRouter, RouterProvider } from "react-router-dom";
import React from "react";

const EventsDetails = React.lazy(() => import("./pages/eventsDetails"));
const NewsDetails = React.lazy(() => import("./pages/newsDetails"));
const ActivityDetails = React.lazy(() => import("./pages/activityDetails"));
const EspacoDetails = React.lazy(() => import("./pages/espacoDetails"));
const OtherRents = React.lazy(() => import("./pages/otherRentsPage"));
const Activities = React.lazy(() => import("./pages/activities"));
const MainLayout = React.lazy(() => import("./layouts/mainLayout"));
const Associese = React.lazy(() => import("./pages/associese"));
const Contacts = React.lazy(() => import("./pages/contact"));
const Events = React.lazy(() => import("./pages/events"));
const Rents = React.lazy(() => import("./pages/rentsPage"));
const About = React.lazy(() => import("./pages/about"));
const Error = React.lazy(() => import("./pages/error"));
const Home = React.lazy(() => import("./pages/home"));
const News = React.lazy(() => import("./pages/news"));

const Routes = () => {
  const publicRoutes = [
    {
      id: 1,
      path: "/",
      element: <MainLayout />,
      errorElement: <Error />,
      children: [
        { id: 1, path: "", element: <Home />, errorElement: <Error /> },
        { id: 2, path: "sobrenos", element: <About />, errorElement: <Error /> },
        { id: 3, path: "atividades", element: <Activities />, errorElement: <Error /> },
        { id: 4, path: "contatos", element: <Contacts />, errorElement: <Error /> },
        { id: 5, path: "espacos", element: <Rents />, errorElement: <Error /> },
        { id: 6, path: "noticias", element: <News />, errorElement: <Error /> },
        { id: 7, path: "eventos", element: <Events />, errorElement: <Error /> },
        { id: 8, path: "noticias/:slug", element: <NewsDetails />, errorElement: <Error /> },
        { id: 9, path: "eventos/:slug", element: <EventsDetails />, errorElement: <Error /> },
        { id: 10, path: "associe-se", element: <Associese />, errorElement: <Error /> },
        { id: 11, path: "atividades/:slug", element: <ActivityDetails />, errorElement: <Error /> },
        { id: 12, path: "espacos/:slug", element: <EspacoDetails />, errorElement: <Error /> },
        { id: 13, path: "outros-espacos", element: <OtherRents />, errorElement: <Error /> },
      ],
    },
  ];

  const router = createBrowserRouter([...publicRoutes]);

  return <RouterProvider router={router} />;
};

export default Routes;
